import React from 'react';

import { useProjectContextValue } from '@qality/common-components/src/lib/QAlityPageConfiguration';
import { LoadingButtonWithTooltip } from '@qality/common-components/src/molecules/LoadingButtonWithTooltip';

import { useTestCaseRepositoryFoldersContext } from '../../TestCaseRepositoryFoldersProvider';
import { useTestCaseRepositoryIssuesContext } from '../../TestCaseRepositoryIssuesProvider';

export function CreateTestCaseButton(): JSX.Element {
  const project = useProjectContextValue();
  const { currentFolder, currentView } = useTestCaseRepositoryFoldersContext();
  const { createTestCases } = useTestCaseRepositoryIssuesContext();

  const handleCreateTestCase = () => {
    createTestCases(project);
  };

  const isInFolderAndCannotEditFolder = currentFolder && !currentFolder.canEdit;

  return (
    <LoadingButtonWithTooltip
      loadingButtonProps={{
        appearance: 'primary',
        onClick: handleCreateTestCase,
        isDisabled: isInFolderAndCannotEditFolder,
      }}
      tooltipProps={{
        content:
          isInFolderAndCannotEditFolder &&
          "You don't have permission to add test cases to this folder.",
      }}
    >
      {currentView === 'all-test-cases'
        ? 'Create Test Case'
        : 'Create Test Case in this Folder'}
    </LoadingButtonWithTooltip>
  );
}
